import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { StakingPlan } from 'src/models';

const OptionTab = ({
  activeTab,
  setActiveTab,
  planStake,
  est
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tab, activeTab === 0 ? styles.active : styles.leftInactive),
    onClick: () => setActiveTab(0)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.name
  }, /*#__PURE__*/React.createElement("span", null, "High Rewards Stake")), /*#__PURE__*/React.createElement("span", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.apr
  }, "APR : ", est[planStake], "%"), /*#__PURE__*/React.createElement("span", {
    className: styles.tag
  }, /*#__PURE__*/React.createElement("span", null, "Best choice")))), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tab, activeTab === 1 ? styles.active : styles.rightInactive),
    onClick: () => setActiveTab(1)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.name
  }, /*#__PURE__*/React.createElement("span", null, "Flexible Stake")), /*#__PURE__*/React.createElement("span", {
    className: styles.info
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.apr
  }, "APR : ", est[StakingPlan.FLEXIBLE], "%"))));
};

export default OptionTab;